import { IconComponent } from "@nova/component-icons"
import { OrthoPalettes, DistanceUnit } from "@nova/constants"
import * as Icons from "@nova/component-icons"

type AcceptablePalettes = Exclude<OrthoPalettes, OrthoPalettes.ScanArea>
type PaletteIcons = { default: IconComponent; selected?: IconComponent }

const iconByPalette: Record<AcceptablePalettes, PaletteIcons> = {
    [OrthoPalettes.WhiteHot]: {
        default: Icons.GradientDefault,
        selected: Icons.GradientDefaultSelected,
    },
    [OrthoPalettes.BlackHot]: { default: Icons.GradientBlackHot },
    [OrthoPalettes.Tint]: { default: Icons.GradientTint },
    [OrthoPalettes.IronRed]: { default: Icons.GradientIronRed },
    [OrthoPalettes.Fulgurite]: { default: Icons.GradientFulgurite },
    [OrthoPalettes.Medical]: { default: Icons.GradientMedical },
}

const palettes = [
    OrthoPalettes.WhiteHot,
    OrthoPalettes.BlackHot,
    OrthoPalettes.Tint,
    OrthoPalettes.IronRed,
    OrthoPalettes.Fulgurite,
    OrthoPalettes.Medical,
]

// This enforces the order of keys.
export const paletteIcons = palettes.map(
    (palette) =>
        [palette, iconByPalette[palette as AcceptablePalettes]] as [OrthoPalettes, PaletteIcons]
)

export const perimeterDistanceOptions: DistanceUnit[] = [
    DistanceUnit.Feet,
    DistanceUnit.Miles,
    DistanceUnit.Meters,
    DistanceUnit.Kilometers,
]

export const bufferColors = ["#FF0000", "#FF6900", "#FFFF00"]
